/* @flow */

import UnderlyingDataAction from "./UnderlyingDataAction";
import UnderlyingRecordsAction from "./UnderlyingRecordsAction";
// import GenerateDashboardAction from "./GenerateDashboardAction";

export const DEFAULT_ACTIONS = [
  UnderlyingDataAction,
  UnderlyingRecordsAction,
  // GenerateDashboardAction,
];



// WEBPACK FOOTER //
// ./qb/components/actions/index.js